<template>
  <v-card
    class="card py-1 px-3"
    :class="classesCss"
    @click="selecao"
  >
    <p class="font-16 pt-1" v-text="card.titulo" />
    <p v-if="!loading" class="font-26 font-weight-bold" v-text="card.total" />
    <v-progress-linear v-else class="mt-4" indeterminate rounded color="red" />
  </v-card>
</template>

<script>
export default {
  name: "CardQuantidadeTotal",
  props: {
    card: {
      type: Object,
      required: true
    },
    loading: Boolean
  },
  computed: {
    classesCss() {
      return {
        ativo: this.card.ativo,
        'nao-ativo': !this.card.ativo
      }
    }
  },
  methods: {
    selecao() {
      this.$emit('card-selecionado', this.card)
    }
  }
}
</script>

<style scoped>
.card {
  height: 70px;
}
.ativo {
  color: #fbfbfb;
  background-color: #A51B32;
}
.nao-ativo {
  color: #363535;
  background-color: white;
}
p {
  margin: 0;
}
</style>
